export const FETCHER_MODE = {
  DRUPAL: "drupal",
  MIDDLEWARE: "middleware"
};
